import { render } from "./ReassignDeliveryRoute.vue?vue&type=template&id=0655b30e&scoped=true"
import script from "./ReassignDeliveryRoute.vue?vue&type=script&lang=js"
export * from "./ReassignDeliveryRoute.vue?vue&type=script&lang=js"

import "./ReassignDeliveryRoute.vue?vue&type=style&index=0&id=0655b30e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0655b30e"]])

export default __exports__